import React from "react";

import { LockBlue } from "@/lib/imageIcon";

const LockCard = () => {
  return (
    <div className="stock-score tykr-score-box lock-card-div">
      <div className="lock-label">
        <img alt="" src={LockBlue} width={12} height={12} />
      </div>

      <div className="lock-card-text">
        Enter your name and email to show results.
      </div>
    </div>
  );
};

export default LockCard;
